import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, ValidatorFn } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DateValidators } from 'app/modules/common/validators/date.validators';
import moment, { Moment } from 'moment';
import {
    ActionCutData,
    ActuationService,
} from '../../services/actuation.service';

export type CutActuationsDialogData = {
    actionId: number;
    actionFecha: string;
    leaveId: number;
};

const CUT_OPTIONS = {
    ESTA_ACTUACION: 'Esta actuación',
    HASTA_FECHA: 'Hasta fecha',
};

@Component({
    selector: 'app-cut-actuations-dialog',
    templateUrl: './cut-actuations-dialog.component.html',
    styleUrls: ['./cut-actuations-dialog.component.scss'],
    standalone: false
})
export class CutActuationsDialogComponent implements OnInit {
    public form: UntypedFormGroup;
    public cutOptions = CUT_OPTIONS;
    public minDate: Moment;

    constructor(
        @Inject(MAT_DIALOG_DATA) private data: CutActuationsDialogData,
        private dialogRef: MatDialogRef<CutActuationsDialogComponent>,
        private fb: UntypedFormBuilder,
        private actionService: ActuationService
    ) {}

    ngOnInit() {
        this.minDate = moment(this.data.actionFecha);

        this.initForm();
    }

    private initForm() {
        this.form = this.fb.group(
            {
                cutOption: this.cutOptions.ESTA_ACTUACION,
                hastaFechaField: [
                    null,
                    [DateValidators.minDate(moment(this.data.actionFecha))],
                ],
            },
            {
                validators: [this.uptoDateFieldValidator()],
            }
        );
    }

    /**
     * Upto date field validator. If the upto date field is required `{ required: true }`
     * is returned
     */
    uptoDateFieldValidator(): ValidatorFn {
        return (control: UntypedFormGroup): { [key: string]: any } | null => {
            const uptoDateField = control.get('hastaFechaField');
            const cutOptionFeild = control.get('cutOption');

            return cutOptionFeild.value === this.cutOptions.HASTA_FECHA &&
                !uptoDateField.value
                ? { hastaFechaFieldRequired: true }
                : null;
        };
    }

    public close() {
        this.dialogRef.close();
    }

    /**
     * Cut the actuations (move)
     */
    public cut() {
        this.form.markAllAsTouched();
        if (!this.form.valid) return;

        let actionCutData = this.buildActionCutData();

        this.actionService.cutActions(actionCutData);

        this.dialogRef.close();
    }

    /**
     * Build action cut data
     */
    private buildActionCutData(): ActionCutData {
        let data: ActionCutData;

        if (
            this.form.get('cutOption').value === this.cutOptions.ESTA_ACTUACION
        ) {
            data = {
                actionId: this.data.actionId,
            };
        } else {
            data = {
                laeveId: this.data.leaveId,
                fecha: moment(this.data.actionFecha),
                hasta: moment(this.form.get('hastaFechaField').value),
            };
        }
        return data;
    }
}
